import { computed, ref } from 'vue'
import type { OcrBlock, PageState } from '@/types/ainotebook'

export function useNotebookState() {
  const selectedFile = ref<File | null>(null)
  const pages = ref<PageState[]>([])
  const pdfLoaded = ref(false)
  const currentPageNumber = ref(1)
  const selectedBlockId = ref('')
  const showMobileEditor = ref(false)
  const ocrLang = ref<'eng'|'chi_tra'|'chi_sim'|'jpn'|'kor'>('eng')

  const docTitle = computed(() => selectedFile.value?.name || 'Untitled.pdf')
  const analyzedCount = computed(() => pages.value.filter(p => p.analyzed).length)
  const currentPage = computed(() => pages.value.find(p => p.pageNumber === currentPageNumber.value) || null)
  const currentPageBlocks = computed(() => currentPage.value?.blocks ?? [])

  const selectedBlock = computed<OcrBlock | null>({
    get() {
      const p = currentPage.value
      if (!p) return null
      return p.blocks.find(b => b.id === selectedBlockId.value) || null
    },
    set(val) {
      if (!val) return
      const p = currentPage.value
      if (!p) return
      const idx = p.blocks.findIndex(b => b.id === selectedBlockId.value)
      if (idx !== -1) p.blocks[idx] = val
    }
  })

  return {
    selectedFile, pages, pdfLoaded, currentPageNumber,
    selectedBlockId, showMobileEditor, ocrLang,
    docTitle, analyzedCount, currentPage, currentPageBlocks, selectedBlock,
  }
}
